import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Typography, Button } from '@material-ui/core';
import axios from 'axios'


const useStyles = makeStyles(theme => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '100%',
      },
    },
  }));



export default function Submit() {
    const classes = useStyles();
    const [source, setSource] = React.useState();
    const [suspect, setSuspect] = React.useState();
    const [feedback, setFeedback] = React.useState();
    
    

    const handleSubmit = () => {
        console.log(source)
        console.log(suspect)
        console.log(feedback)
        axios
			.post(`/submit`, {source, suspect, feedback})
			.then(response => {
				alert("Thank you for submitting! We'll review and update as soon as possible!")
				
			})
			.catch((err) => {});
//        const review = details.trim();
//        const sender = source;
//        if (!review) {
//        	return
//        }
//        
//        axios
//        	.post(`/cse/courses/addreview/${courseId}`, {courseId, source, courseName, details})
//        	.then(response => {
//        		alert("Thank you for submitting! We'll review your post and post them as soon as possible!")
//        		setOpen(false)
    //        
//        	})
//        			.catch((err) => {});
	}











    return (
        <div>
        <div>
            <Typography className={classes.root}>Please submit new reliable sources for this app to use!<br /> You have to fill out everything to successfully submit</Typography>
            <form className={classes.root} noValidate autoComplete="off">
            <TextField
    required
    id="outlined-required"

                label="Reliable sources"
                placeholder="www.example.com"
                multiline
                variant="outlined"
                value={source}
			    onChange={(e) => setSource(e.target.value)}
                />
            </form>
        </div>
        <div>
        <Typography className={classes.root}>Any suspicious areas?</Typography>
        <form className={classes.root} noValidate autoComplete="off">
        <TextField
    required
    id="outlined-required"

            label=""
            placeholder="e.g. North Sydney"
            multiline
            variant="outlined"
            value={suspect}
            onChange={(e) => setSuspect(e.target.value)}
            />
        </form>
    </div>
    <div>
        <Typography className={classes.root}>Any feedbacks?</Typography>
        <form className={classes.root} noValidate autoComplete="off">
        <TextField
    required
    id="outlined-required"

            label="Feedback"
            placeholder="Please be kind!"
            multiline
            variant="outlined"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            />
        </form>
    </div>
    <Button onClick={handleSubmit} color="primary">
			Submit
    </Button>
    </div>
    )
}
